export default __webpack_public_path__ + "static/hero-10-b5c67c7026376fb2178c9d55cce3c863.webp";